import React, { useEffect } from "react";
import { Texture } from 'pixi.js'
import { Sprite, Container, withFilters } from '@inlet/react-pixi'
import { GlowFilter } from 'pixi-filters';
import { ease } from 'pixi-ease'

const Filters = withFilters(Container, {
    glow: GlowFilter,
});

const MonsterEggContainer = ({ _openMessageBox, _eggUrl }) => {
    const [filter, setFilter] = React.useState(0);
    const eggId = React.useRef();

    useEffect(() => {
        if (eggId.current !== null && eggId.current !== undefined) {
            ease.add(eggId.current, { shake: 2 }, { repeat: true })
        }
    }, []);

    return (
        <Filters scale={1} glow={{ distance: 100, outerStrength: filter, innerStrength: filter / 4, quality: 0, color: '0xf5f5f5' }}>
            <Sprite ref={eggId} x={500} y={200} scale={{ x: 0.05, y: 0.05 }} texture={Texture.from(_eggUrl)}
                buttonMode={true} interactive={true}
                pointerdown={() => { _openMessageBox() }}
                pointerover={() => setFilter(4)}
                pointerout={() => setFilter(0)}
            />
        </Filters>
    );
};

export { MonsterEggContainer as default }